import CommonDataProtection from '@/modules/common/hiring/models/MID/CommonDataProtection'
import LifePolicyHolderToSave from '../LifePolicyHolderToSave'

export default class LifeSavePolicyHolderRequest {
  quotationId!: string
  policyHolder!: LifePolicyHolderToSave
  dataProtection!: CommonDataProtection

  constructor(data: any) {
    this.quotationId = data.quotationId

    if (data.policyHolder) {
      this.policyHolder = new LifePolicyHolderToSave(data.policyHolder)
    }

    if (data.dataProtection) {
      this.dataProtection = new CommonDataProtection(data.dataProtection)
    }
  }
}
